var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaskdashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 4.59961H16.6C17.0774 4.59961 17.5352 4.76818 17.8728 5.06824C18.2104 5.3683 18.4 5.77526 18.4 6.19961V17.3996C18.4 17.824 18.2104 18.2309 17.8728 18.531C17.5352 18.831 17.0774 18.9996 16.6 18.9996H5.8C5.32261 18.9996 4.86477 18.831 4.52721 18.531C4.18964 18.2309 4 17.824 4 17.3996V6.19961C4 5.77526 4.18964 5.3683 4.52721 5.06824C4.86477 4.76818 5.32261 4.59961 5.8 4.59961H7.6",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8999 3H8.49991C8.00286 3 7.59991 3.35817 7.59991 3.8V5.4C7.59991 5.84183 8.00286 6.2 8.49991 6.2H13.8999C14.397 6.2 14.7999 5.84183 14.7999 5.4V3.8C14.7999 3.35817 14.397 3 13.8999 3Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskdashboard);
export default __webpack_public_path__ + "static/media/task dashboard.4600b2519b35678f0cc490742032564a.svg";
export { ForwardRef as ReactComponent };